export default __webpack_public_path__ + "static/media/gif4.61994e7b.gif";